export enum DateFormat {
  HOUR_01 = 'HH',
  HOUR_02 = 'HH:mm',
  HOUR_03 = 'HH:mm:ss',
  DATE_01 = 'YYYY-MM-DD',
  DATE_02 = 'MM/DD/YYYY',
  DATE_03 = 'MMM D, YYYY',
  DATE_04 = 'MMMM yyyy',
  DATETIME_01 = 'YYYY-MM-DD HH:mm:ss',
  DATETIME_02 = 'MM/DD/YYYY HH:mm:ss',
  DATETIME_03 = 'MMM D, YYYY HH:mm:ss',
  START_HOUR = ' 00:00:00',
  END_HOUR = ' 23:59:59',
  MIDDLE_HOUR = ' 12:00:00'
}

/** Angular DatePipe default format — use with DATE_PIPE_DEFAULT_OPTIONS */
export const ANGULAR_DATE_FORMAT = 'MM/dd/yyyy';
